import { map, join, isNumber } from 'lodash';
/**
 * Takes in our JSON format and converts to an odata filter
 *
 * @returns {string} an odata filter string
 */
export const makeOdataFilter = (filterObj = {}) => {
    const arr = mapFilterProps(filterObj);
    if (arr.length <= 0) {
        // there were no filters
        return null;
    }
    //combine all filters into one giant filter
    return `$filter=${join(arr, ' and ')}`;
};
/** Iterate over filter items and process them. Recursively walks any that are an ODataOrProperty */
const mapFilterProps = (filterObj) => map(filterObj, (val, name) => {
    // Support injection via function
    if (val instanceof Function) {
        const res = val();
        // Allow overriding with manual string text
        if (typeof res === 'string') {
            return res;
        }
        // Allow injection via anonymous function that returns recursion of this funciton
        return mapFilterProps(res);
    }
    //remove null/falsey filters
    if (!val) {
        return false;
    }
    //handle arrays
    if (Array.isArray(val)) {
        if (val.length < 1) {
            return false;
        }
        // Searching any value from an array has the following syntax:
        // name in ('thing1','thing2','thing3')
        return `${name} in ('${join(val, "','")}')`;
    }
    // Support directly returning strings
    if (typeof val === 'string') {
        // eslint-disable-next-line eqeqeq -- I want to coerce both `undefined` and 'undefined' here
        if (val == 'undefined') {
            return false;
        }
        return val;
    }
    // Handle standard IODataItem extensions
    if (val.data || val.operator) {
        // Support OData "any" (anywhere within array) filters
        // Looks like {data:T,operator?:ODataOperator,type:'any'}
        if (val.type === 'any') {
            return `${name}/any(val: val ${val.operator || 'eq'} '${val.data}')`;
        }
        // Handle date requests
        if (val.data instanceof Date || val.type === 'date') {
            const cleanDate = mergeDateTypes(val.data);
            return `${name} ${val.operator || 'eq'} ${cleanDate.toISOString()}`;
        }
        // Operator-based behavior (operator omitted for direct equalities "name eq value")
        return `${name} ${val.operator || 'eq'} ${val.data}`;
    }
    if (Object.keys(val).length > 0) {
        //handle "or" logic
        return `${mapOrSegment(val)}`;
    }
}).filter(val => !!val); //remove nulls
const mapOrSegment = (prop) => {
    const renderedSubSegments = mapFilterProps(prop);
    return `(${renderedSubSegments.join(' or ')})`;
};
const mergeDateTypes = (d) => {
    if (d instanceof Date) {
        return d;
    }
    if (isNumber(d)) {
        return new Date(d);
    }
    return new Date(d);
};
